<div class="c7-root">

<p-toast></p-toast>
<router-outlet></router-outlet>

</div>
